import { render, staticRenderFns } from "./CharterPartyContractRecord.vue?vue&type=template&id=6524f66c&scoped=true"
import script from "./CharterPartyContractRecord.vue?vue&type=script&lang=js"
export * from "./CharterPartyContractRecord.vue?vue&type=script&lang=js"
import style0 from "./CharterPartyContractRecord.vue?vue&type=style&index=0&id=6524f66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524f66c",
  null
  
)

export default component.exports